import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/CombinedAuthContext";
import "../styles/LoginCallback.css"; // Reuse existing styling

const TokenLogin = () => {
  const [status, setStatus] = useState("Processing token login...");
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSessionToken } = useAuth();
  const processedRef = useRef(false);

  useEffect(() => {
    // Use sessionStorage to prevent repeat processing
    const tokenProcessed = sessionStorage.getItem("token_processed");
    if (tokenProcessed === "true" || processedRef.current) {
      setIsProcessing(false);
      setStatus("Already processed token login.");
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 1000);
      return;
    }

    async function processToken() {
      try {
        console.log("[DEBUG] [TokenLogin] Processing token login...");
        processedRef.current = true;
        sessionStorage.setItem("token_processed", "true");

        const params = new URLSearchParams(location.search);
        const sessionToken = params.get("token");
        const fallbackEmail =
          params.get("fallbackEmail") || "perrynally@gmail.com"; // Use fallback

        if (!sessionToken) {
          setError("No sessionToken found in URL");
          setStatus("Login Failed");
          setIsProcessing(false);
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 1000);
          return;
        }

        console.log("Processing sessionToken login...");

        // Clean URL parameters immediately to prevent further processing attempts
        window.history.replaceState({}, document.title, "/");

        console.log("Calling handleSessionToken...");
        const result = await handleSessionToken(sessionToken, fallbackEmail);
        console.log("...returned from handleSessionToken.");

        console.log("Result:", result);

        if (result?.success) {
          setStatus("Login successful! Redirecting...");
          sessionStorage.removeItem("token_redirect_done");
          sessionStorage.removeItem("token_processed");
          setTimeout(() => {
            navigate("/", { replace: true });
          }, 1000);
        } else {
          setError(result?.error || "Authentication failed");
          setStatus("Login Failed");
          setIsProcessing(false);
          // Allow retry by clearing the processed flag
          sessionStorage.removeItem("token_processed");
        }
      } catch (e) {
        console.error("Token login error:", e);
        setError(e.message || "Authentication failed");
        setStatus("Login Failed");
        setIsProcessing(false);
        // Allow retry by clearing the processed flag
        sessionStorage.removeItem("token_processed");
      }
    }

    processToken();
  }, [location, handleSessionToken, navigate]);

  return (
    <div className="login-callback-container">
      <div className="login-callback-card">
        <h2>Authentication</h2>
        <p>{status}</p>
        {isProcessing && (
          <div className="loading-spinner">
            <p>Loading...</p>
          </div>
        )}
        {!isProcessing && error && (
          <div className="error-message">
            <p>Error: {error}</p>
            <button
              onClick={() => {
                sessionStorage.removeItem("token_processed");
                window.location.reload();
              }}
            >
              Retry
            </button>
            <button onClick={() => navigate("/")}>Continue</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TokenLogin;
